class BlogTagFilter extends HTMLElement {
  constructor() {
    super();

    this.selectorPostsContainer = ".main-blog-posts-container";
    this.selectorTagsContainer = ".main-blog-tag-filter__items";
    this.selectorBreadcrumbs = "#breadcrumbs";

    this.postsContainer = document.querySelector(this.selectorPostsContainer);
    this.tagsContainer = document.querySelector(this.selectorTagsContainer);
    this.breadcrumbs = document.querySelector(this.selectorBreadcrumbs);
    this.cachedData = {};

    this.onTagClick = this.onTagClick.bind(this);

    this.addEventListeners(this.querySelectorAll(".js-filter-link"));
  }

  addEventListeners(tags) {
    tags.forEach((tag) => tag.addEventListener("click", this.onTagClick));
  }

  onTagClick(event) {
    event.preventDefault();
    const tag = event.currentTarget;
    if (!tag.classList.contains("js-filter-link")) return;
    const url = tag.getAttribute("data-url");
    this.renderPage(url);
  }

  renderPage(url) {
    if (this.cachedData[url]) {
      this.renderSectionFromCache(url);
      return;
    }

    this.renderSectionFromFetch(url);
  }

  renderSectionFromFetch(url) {
    this.postsContainer?.classList.add("loading");
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error. Status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        this.cachedData = {
          ...this.cachedData,
          [url]: html,
        };
        this.renderBreadcrumbs(html);
        this.renderFilters(html);
        this.renderBlogContainer(html);
        this.updateArticlesCount(html);
        this.updateBrowserUrl(url);
      })
      .catch((error) => {
        console.error("Error loading blog posts:", error);
      })
      .finally(() => {
        this.postsContainer.classList.remove("loading");
      });
  }

  renderSectionFromCache(url) {
    const html = this.cachedData[url];
    this.renderBreadcrumbs(html);
    this.renderFilters(html);
    this.renderBlogContainer(html);
    this.updateArticlesCount(html);
    this.updateBrowserUrl(url);
  }

  renderBreadcrumbs(html) {
    if (!this.breadcrumbs) return;
    this.breadcrumbs.innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(this.selectorBreadcrumbs).innerHTML;
  }

  renderFilters(html) {
    if (!this.tagsContainer) return;
    this.tagsContainer.innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(this.selectorTagsContainer).innerHTML;

    this.addEventListeners(this.querySelectorAll(".js-filter-link"));
  }

  updateArticlesCount(html) {
    const count =
      new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("ArticleCount")?.innerHTML || "";
    const container = document.getElementById("ArticleCount");

    if (container) {
      container.innerHTML = count;
      container.classList.remove("loading");
    }
  }

  renderBlogContainer(html) {
    if (!this.postsContainer) return;
    const parsedDOM = new DOMParser().parseFromString(html, "text/html");
    if (!parsedDOM) return;
    this.postsContainer.innerHTML = parsedDOM.querySelector(
      this.selectorPostsContainer
    )?.innerHTML;

    if (
      document.querySelector(".js-load-more") ||
      document.querySelector(".js-infinite-scroll")
    ) {
      initLoadMore();
    }
  }

  updateBrowserUrl(path, clearFilters = false) {
    window.history[clearFilters ? "replaceState" : "pushState"]({}, "", path);
  }
}

if (!customElements.get("blog-tag-filter")) {
  customElements.define("blog-tag-filter", BlogTagFilter);
}

(function () {
  const initSlideshow = (section) => {
    const sliderEls = section.querySelectorAll(".js-featured-swiper");

    if (!sliderEls.length) return;
    sliderEls?.forEach((sliderEl) => {
      if (sliderEl.swiper) sliderEl.swiper.destroy();
      const slidesEl = sliderEl.querySelectorAll(".js-featured-swiper-slide");

      if (!slidesEl?.length && slidesEl.length < 2) return;

      const animationType = sliderEl.dataset?.animationType || "slide";
      const paginationEl = section.querySelector(".slider-pagination");
      const nextBtn = section.querySelector(".slider-nav-button--next");
      const prevBtn = section.querySelector(".slider-nav-button--prev");
      const sliderLoop = sliderEl.getAttribute("data-loop") === "true";
      const hasSliderAutoplay =
        sliderEl.getAttribute("data-autoplay") === "true";
      const pauseAutoplayOnHover =
        sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
      const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 5000);
      const hasParallax = sliderEl.getAttribute("data-parallax") === "true";
      slidesEl.forEach((el) => {
        el.classList.add("swiper-slide");
        if (hasParallax) {
          const container = el.querySelector(".main-blog__slider-content");
          container?.setAttribute("data-swiper-parallax", "-700");
        }
      });
      new Swiper(sliderEl, {
        loop: sliderLoop,
        slidesPerView: 1,
        spaceBetween: 12,
        speed: animationType === "creative" ? 1000 : 800,
        watchSlideProgress: true,
        allowTouchMove: true,
        effect: animationType,
        creativeEffect:
          animationType === "creative"
            ? {
                prev: {
                  shadow: true,
                  translate: ["-20%", 0, -1],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              }
            : {},
        resistanceRatio: animationType === "creative" ? 0 : 0.85,
        parallax: hasParallax,
        mousewheel: {
          forceToAxis: true,
        },
        autoplay: hasSliderAutoplay
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: pauseAutoplayOnHover,
            }
          : false,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: {
          576: {
            spaceBetween: 20,
          },
        },
        on: {
          autoplayTimeLeft(s, time, progress) {
            if (paginationEl) {
              paginationEl.style.setProperty("--slider-progress", 1 - progress);
            }
          },
          slideChangeTransitionStart() {
            if (animationType === "creative") {
              this.allowSlideNext = false;
              this.allowSlidePrev = false;
              this.allowTouchMove = false;

              const prevSlide = this.slides[this.previousIndex];
              const prevContent = prevSlide?.querySelector(
                ".main-blog__slider-content-container"
              );
              if (prevContent) {
                prevContent.style.transition = "opacity 0.3s ease";
                prevContent.style.opacity = "0";
              }
            }
          },
          slideChangeTransitionEnd() {
            if (animationType === "creative") {
              this.allowSlideNext = true;
              this.allowSlidePrev = true;
              this.allowTouchMove = true;

              const prevSlide = this.slides[this.previousIndex];
              const prevContent = prevSlide?.querySelector(
                ".main-blog__slider-content-container"
              );
              if (prevContent) {
                prevContent.removeAttribute("style");
              }
            }
          },
        },
      });
    });
  };

  initSlideshow(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlideshow(event.target);
  });
})();
